import React from "react";

const AuditLogs = ({ auditLogs }) => (
    <section className="card">
        <h3>Audit Logs</h3>
        <table>
            <thead>
                <tr>
                    <th>User</th>
                    <th>Action</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                {auditLogs.map((log, i) => (
                    <tr key={i}>
                        <td>{log.user}</td>
                        <td>{log.action}</td>
                        <td>{log.date}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </section>
);

export default AuditLogs;